/**
 * @generated SignedSource<<503704bd8b0ecc9d4650a7a57193548a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type SquareGiftCardStatus = "ACTIVE" | "BLOCKED" | "DEACTIVATED" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type GiftCard_squareGiftCard$data = {
  readonly __typename: "SquareGiftCard";
  readonly balance: number;
  readonly createdAt: string;
  readonly ganLastFour: string | null | undefined;
  readonly id: string;
  readonly squareId: string;
  readonly status: SquareGiftCardStatus;
  readonly " $fragmentType": "GiftCard_squareGiftCard";
};
export type GiftCard_squareGiftCard$key = {
  readonly " $data"?: GiftCard_squareGiftCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"GiftCard_squareGiftCard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GiftCard_squareGiftCard",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "balance",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ganLastFour",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "squareId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "type": "SquareGiftCard",
  "abstractKey": null
};

(node as any).hash = "31ba270a83d3846105da850e22e69299";

export default node;
